module.exports = __webpack_public_path__ + "static/media/brian.182ac2d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/aeropost/brian.jpg
// module id = 1207
// module chunks = 0